import { render, staticRenderFns } from "./ShowsCard.vue?vue&type=template&id=619130fb"
import script from "./ShowsCard.vue?vue&type=script&lang=js"
export * from "./ShowsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports